module.exports = __webpack_public_path__ + "static/media/play-video.052ed90a.svg";